import { ContextSwitcher } from '@/components/shell/context-switcher';
import { RequireAuth } from '@/components/shell/require-auth';
import { UserMenu } from '@/components/shell/user-menu';
import { cn } from '@/lib/cn';
import { Link, Outlet, createFileRoute, useRouterState } from '@tanstack/react-router';
import { Boxes, Image, Layers, Palette, Settings, Users } from 'lucide-react';

export const Route = createFileRoute('/_authed')({
  component: Shell,
});

const NAV = [
  { to: '/campaigns', label: 'Campaigns', icon: Boxes },
  { to: '/experiences', label: 'Experiences', icon: Layers },
  { to: '/segments', label: 'Segments', icon: Users },
  { to: '/assets', label: 'Assets', icon: Image },
  { to: '/theme', label: 'Theme', icon: Palette },
  { to: '/settings', label: 'Settings', icon: Settings },
] as const;

function Shell(): React.ReactNode {
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  return (
    <RequireAuth>
    <div className="flex h-screen flex-col bg-background">
      <header className="flex h-12 shrink-0 items-center gap-4 border-b px-4">
        <Link to="/campaigns" className="font-semibold tracking-tight">
          PersonalizeHQ
        </Link>
        <ContextSwitcher />
        <div className="ml-auto">
          <UserMenu />
        </div>
      </header>

      <div className="flex min-h-0 flex-1">
        <nav className="w-[220px] shrink-0 border-r p-2">
          {NAV.map(({ to, label, icon: Icon }) => {
            const active = pathname.startsWith(to);
            return (
              <Link
                key={to}
                to={to}
                className={cn(
                  'flex items-center gap-2 rounded-lg px-3 py-2 text-sm transition-colors',
                  active
                    ? 'bg-secondary font-medium text-foreground'
                    : 'text-muted-foreground hover:bg-secondary/60 hover:text-foreground'
                )}
              >
                <Icon className="size-4" />
                {label}
              </Link>
            );
          })}
        </nav>

        <main className="min-w-0 flex-1 overflow-y-auto">
          <div className="mx-auto max-w-5xl p-8">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
    </RequireAuth>
  );
}
